import { useEffect } from 'react';
const scrollKeys = ['ArrowUp', 'ArrowDown'];
export default function usePreventScroll(prevent) {
  useEffect(() => {
    const preventScroll = event => {
      if (prevent && scrollKeys.includes(event.code)) event.preventDefault();
    };
    global.addEventListener('keydown', preventScroll, false);
    return () => global.removeEventListener('keydown', preventScroll, false);
  }, [prevent]);
}